export default '/build/f4dc269e.svg'